<template>
  <vx-card>
    <vs-table id="table" pagination search class="my-5" no-data-text="لا يوجد أساتذة" :data="teachers" :total="teachers.length">

      <div slot="header" class="flex">
        <vs-button @click="exportToExcel" class="mt-4 md:mt-0 sm:ml-3 w-full sm:w-auto">إستخراج xlsx</vs-button>
        <vs-button v-if="hasRole('assign_teachers')" @click="isFormActive = true" class="mt-4 md:mt-0 sm:ml-3 w-full sm:w-auto" color="success">تعيين أستاذ</vs-button>
      </div>

      <template slot="thead">
        <vs-th sort-key="first_name">إسم الاستاذ</vs-th>
        <vs-th sort-key="middle_name">إسم الأب</vs-th>
        <vs-th sort-key="last_name">اللقب</vs-th>
        <vs-th sort-key="email">البريد الإلكتروني</vs-th>
        <vs-th sort-key="status">الحالة</vs-th>
        <vs-th sort-key="created_at">تاريخ التسجيل</vs-th>
        <vs-th>العمليات</vs-th>
      </template>

      <tbody slot-scope="{data}">
      <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
        <vs-td :data="tr.first_name">{{ tr.first_name }}</vs-td>
        <vs-td :data="tr.middle_name">{{ tr.middle_name }}</vs-td>
        <vs-td :data="tr.last_name">{{ tr.last_name }}</vs-td>
        <vs-td :data="tr.email">
          <div class="flex items-center">
            {{ tr.email }}
            <vx-tooltip :text="tr.is_verified ? 'البريد الإلكتروني مؤكد' : 'البريد الإلكتروني غير مؤكد'" class="cursor-pointer ml-2">
              <vs-icon :icon="tr.is_verified ? 'icon-check' : 'icon-x'" icon-pack="feather"
                       :class="tr.is_verified ? 'bg-success' : 'bg-danger'"
                       class="rounded-full p-px h-3 w-3 text-white"/>
            </vx-tooltip>
            <span v-if="!tr.is_verified && !tr.emailSend" @click="resendEmail(tr)" class="ml-2 text-primary cursor-pointer">إعادة إرسال</span>
          </div>
        </vs-td>
        <vs-td :data="tr.status">
          <vs-chip v-if="tr.status === 0" color="warning">قيد الانتظار</vs-chip>
          <vs-chip v-else-if="tr.status === 1" color="success">مفعل</vs-chip>
          <vs-chip v-else color="danger">موقوف</vs-chip>
        </vs-td>
        <vs-td>{{ tr.created_at | reg_date }}</vs-td>
        <vs-td>
          <div v-if="tr.user_id !== user.id" class="flex">
            <template v-if="hasRole('update_teachers')">
              <vs-button v-if="tr.status !== 1" size="large" title="تفعيل الحساب" color="success" type="flat" class="ml-3 d-inline" icon-pack="feather" icon="icon-check" @click="changeStatus(tr, 1)"></vs-button>
              <vs-button v-else size="large" title="إقاف الحساب" color="warning" type="flat" class="ml-3 d-inline" icon-pack="fa" icon="fa-ban" @click="changeStatus(tr, 2)"></vs-button>
              <vs-button @click="openEditForm(tr)" size="large" title="تعديل" color="primary" type="flat" class="ml-2" icon-pack="feather" icon="icon-edit"></vs-button>
            </template>
            <vs-button v-if="hasRole('delete_teachers')" @click="deleteTeacher(tr)" size="large" title="إزالة" color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
      </tbody>

    </vs-table>

    <teacher-form @submit="save" :active.sync="isFormActive"/>
    <teacher-edit-form @submit="saveEdit" :active.sync="isFormEditActive" :data="teacherData" />
  </vx-card>
</template>

<script>
    import teachersAPI from '@/api/admin/teachersAPI'
    import userAPI from '@/api/admin/userAPI'
    import TeacherForm from '@/views/admin/TeacherForm'
    import TeacherEditForm from '@/views/admin/TeacherEditForm'

    export default {
        components: { TeacherEditForm, TeacherForm },
        data() {
            return {
                headerTitle: ['إسم الاستاذ', 'إسم الأب', 'اللقب', 'البريد الإلكتروني'],
                headerVal: ['first_name', 'middle_name', 'last_name', 'email'],
                teachers: [],
                isFormActive: false,
                isFormEditActive: false,
                teacherData: {}
            }
        },
        methods: {
          openEditForm(teacher) {
            this.teacherData = {...teacher}
            this.isFormEditActive = true
          },
          resendEmail(teacher){
            let message = `هل انت متأكد من أنك تريد إعادة ارسال رسالة تأكيد البريد الإلكتروني إلى "${teacher.email}"؟`
            this.$confirmAlert(null, message, () => {
              userAPI.resendEmail(teacher.user_id).then(response => {
                teacher.emailSend = true;
                this.$forceUpdate()
                this.$notifySuccess(response.successMessage)
              }).catch(error => this.$notifyError(error.statusMessage))
            }, 'warning')
          },
          exportToExcel() {
                import('@/vendor/Export2Excel').then(excel => {
                    const list = this.teachers
                    const data = list.map(value => this.headerVal.map(key => value[key]))
                    excel.export_json_to_excel({
                        header: this.headerTitle,
                        data,
                        filename: 'أعضاء هيئة التدريس',
                        desc: 'أعضاء هيئة التدريس بالكلية'
                    })
                })
            },
            save(data) {
                this.formType !== 'edit' ? this.admins.push(data) :
                    this.admins.find(admin => data.id === admin.id).roles = data.roles
            },
            saveEdit(data){
              const index = this.teachers.findIndex(t => data.id === t.id)
              this.$set(this.teachers, index, data)
            },
            deleteTeacher(teacher){
                let message =  `هل انت متأكد بأنك تريد إزالة حساب الأستاذ من الكلية ${teacher.first_name} ${teacher.last_name}`
                this.$confirmAlert(null, message, () => {
                    teachersAPI.delete(teacher.id)
                        .then(response => {
                            this.teachers.splice(this.teachers.indexOf(teacher), 1)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(response => this.$notifyError(response.statusMessage))
                })
            },
            changeStatus(teacher, status) {
                let doChange = () => {
                    userAPI.changeStatus(teacher.user_id, 'teacher', status)
                        .then(() => teacher.status = status)
                }
                if(status === 1){
                    doChange()
                    return
                }
                this.$confirmAlert(null, 'هل انت متأكد بأنك تريد إقاف تفعيل حساب الإستاذ', () => doChange(), 'warning')
            },
            loadData(){
                this.$startLoading('#table', 'white')
                teachersAPI.getAll().then(({data}) => {
                    this.teachers = data.teachers
                }).finally(() => this.$closeLoading('#table'))

            }
        },
        mounted(){
            this.loadData()
        }
    }

</script>
